import { ComponentPropsWithoutRef } from 'react';

import { cn } from '@components/primitives/utilities';

import css from './styles.module.css';

/** Muted text inside an addon, such as a scheme or a unit. */
export function InputGroupText({
  className,
  ...props
}: ComponentPropsWithoutRef<'span'>) {
  return <span className={cn(css.text, className)} {...props} />;
}
